import * as React from 'react';
import { useEffect } from 'react';
import { UIText1 } from '@cian/ui-kit';

import blockImgSrc from './assets/block.svg';
import { generateErrorBannerShowAction } from '../../../../actions/webview';
import { useAppContext } from '../../../../../AppModulesWrapper';

import * as styles from './SubAgentLimitExceedCard.css';

export const SubAgentLimitExceedCard = () => {
  const { webview } = useAppContext();

  useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('subagent-limit-exceed-error-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles['wrapper']}>
      <img src={blockImgSrc} width="30" height="30" />

      <div className={styles['text']}>
        <UIText1>
          Агентство ограничило вам публикации. Переключитесь на личный счёт, чтобы разместить объявление.
        </UIText1>
      </div>
    </div>
  );
};
